import { Record } from 'immutable'
import { ModalData } from 'utils/ModalHelpers'
import GlobalModalConstants from 'constants/GlobalModalConstants'

const ModalState = Record({
  show: false,
  data: ModalData()
})

class GlobalModalStore extends Marty.Store {
  state = ModalState()

  handlers = {
    openModal: [GlobalModalConstants.MODAL_OPENED],
    closeModal: [GlobalModalConstants.MODAL_CLOSED],
  }

  dehydrate() {
    return this.state.toJS()
  }

  rehydrate(dehydratedState) {
    const { show, data } = dehydratedState
    return ModalState({show, data: ModalData(...data) })
  }

  getModalState() {
    return this.fetch({
      id: 'getModalState',
      locally() {
        return this.state
      }
    })
  }

  openModal(modalData) {
    this.state = this.state.set('show', true).set('data', modalData)
  }

  closeModal() {
    this.state = this.state.set('show', false)
  }
}

export default GlobalModalStore



// WEBPACK FOOTER //
// ./src/scripts/stores/GlobalModalStore.js